import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./slices/app";
import drawerReducer from "./slices/drawer";
import chatSelectionReducer from "./slices/chatSelection";
import documentSelectionReducer from "./slices/documentSelection";
import viewReducer from "./slices/view";
import authReducer from "./slices/auth";
import notificationReducer from "./slices/notification";
import chatReducer from "./slices/chat";
import shopReducer from "./slices/shop";
import userReducer from "./slices/user";
import chatAttachmentReducer from "./slices/chatAttachment";

/**
 * Hier werden die Redux-Slices hinterlegt.
 * Das Kapseln von zusammengehörigen States in Slices den Vorteil, dass bei einem Update eines States
 * nur der zugehörige Slice neu berechnet wird (und ggf. Re-Renders ausgelöst werden).
 * Das erhöht die Performanz, reduziert Komplexität und vereinfacht die Wartung.
 *
 * IMPORTANT Reducer müssen immer mittels dispatch(myReducer(value)) gesetzt werden.
 *
 * https://redux-toolkit.js.org/tutorials/quick-start
 */
export const store = configureStore({
    reducer: {
        app: appReducer,
        auth: authReducer,
        user: userReducer,
        drawer: drawerReducer,
        chatSelection: chatSelectionReducer,
        documentSelection: documentSelectionReducer,
        view: viewReducer,
        notification: notificationReducer,
        chat: chatReducer,
        shop: shopReducer,
        chatAttachment: chatAttachmentReducer,
    },
});

/**
 * Typ-Definition für den gesamten Redux-State.
 * Wird automatisch aus den Reducer-Typen generiert.
 */
export type RootState = ReturnType<typeof store.getState>;
